import { SelectInput, TrashIcon } from "djinn-components";
import React from "react";
import { SiteLinkType } from "../../../types/api";

const UrlInput = ({
  value,
  onChange,
  url,
  id = "url",
  invalid = false,
}: any) => {
  return (
    <label
      className={`w-full flex rounded-r-full shadow-sm bg-gray-700 text-white justify-between items-center sm:text-sm transition duration-500 ease-in-out overflow-hidden ${
        invalid ? "ring-red" : "ring-transparent"
      }`}
      htmlFor={id}
    >
      {/* <div className="w-2/4 bg-gray-500 h-14 flex items-center">
        <span className="text-center px-4 truncate ">{url}</span>
      </div> */}
      <div className="w-2/4 text-left h-14">
        <input
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          className={`input p-4 bg-transparent pl-4 placeholder-gray-400 form-input outline-none focus:outline-none w-full h-14 ring-0 focus:ring-0 border-none focus:border-none`}
          placeholder="Enter url including https"
          autoComplete="off"
        />
      </div>
    </label>
  );
};

interface ProjectLinkInputProps {
  value: SiteLinkType;
  onChange: (val: SiteLinkType) => void;
  invalid?: boolean;
  onDelete: () => void;
}
const ProjectLinkInput: React.FC<ProjectLinkInputProps> = ({
  value,
  onChange,
  invalid = false,
  onDelete,
}) => {
  return (
    <div className="mb-4 flex w-full">
      <div
        className={`sm:col-span-4 flex rounded-ful ring-1 w-full ${
          invalid ? "ring-red-700" : "ring-transparent"
        }`}
      >
        <div className="w-1/3 flex-shrink-0 bg-gray-850 rounded-l-full">
          <SelectInput
            selected={value.type ?? null}
            onSelect={(v) => {
              onChange({ url: value.url, type: v });
            }}
            transparent={true}
            label="Choose Type"
            options={[
              { value: "playstore", key: "Google Play" },
              { value: "appstore", key: "App Store" },
              { value: "macstore", key: "Mac Store" },
              { value: "snapstore", key: "Snap Store" },
              { value: "microsoftstore", key: "Microsoft Store" },
            ]}
          />
        </div>
        <UrlInput
          id="endpoint"
          value={value.url}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange({ url: e.target.value, type: value.type! });
          }}
        />
      </div>

      <button type="button" className="block ml-2" onClick={() => onDelete()}>
        <TrashIcon size={20} className="block text-white hover:text-red-700" />
      </button>
    </div>
  );
};

export default ProjectLinkInput;
